import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserRoleEnum } from '../../backend/model/userRoleEnum';
import { AuthService } from './auth.service';

interface MenuItem {
  title: string;
  path: string;
  icon?: string;
  children?: MenuItem[];
}

export interface Menu {
  userRole: UserRoleEnum;
  items: MenuItem[];
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menus: Menu[] = [];

  constructor(private authService: AuthService, private t: TranslateService) {
    const menuItems = {
      dashboard: {
        title: this.t.instant('dashboard'),
        path: 'dashboard',
        icon: 'fa-chart-line',
      },
      users: {
        title: this.t.instant('users'),
        path: 'users',
        icon: 'fa-user-cog',
      },
      families: {
        title: this.t.instant('families'),
        path: 'families',
        icon: 'fa-users',
      },
      donations: {
        title: this.t.instant('donations'),
        path: 'donations',
        icon: 'fa-box-heart',
      },
      needs: {
        title: this.t.instant('needs'),
        path: 'needs',
        icon: 'fa-box-heart',
      },
      members: {
        title: this.t.instant('members'),
        path: 'members',
        icon: 'fa-users',
      },
      categories: {
        title: this.t.instant('categories'),
        path: 'categories',
        icon: 'fa-users',
      },
      lists: {
        title: this.t.instant('RNS Centar'),
        path: 'lists',
        icon: 'fa-list',
      },
      // organisationMembers: {
      //   title: this.t.instant('organisationMembers'),
      //   path: 'organisationMembers',
      //   icon: 'fa-user-cog',
      // },
    };

    this.menus = [
      {
        userRole: UserRoleEnum.SystemAdministrator,
        items: [
          menuItems.families,
          menuItems.donations,
          menuItems.needs,
          menuItems.members,
          menuItems.lists,
          // menuItems.organisationMembers,
          menuItems.users,
          menuItems.dashboard,
          menuItems.categories,
        ],
      },
    ];
  }

  getCurrentUserRoleMenu() {
    const role = this.authService.getUserRole();
    return this.menus.find((menu) => menu.userRole === role);
  }
}
